// @ts-nocheck
import { useQuery } from "@tanstack/react-query";
import { useEventService } from "@/modules/events/hooks/useEventService";
import { useOrganizationContext } from "@/contexts/OrganizationContext";
import { supabase } from "@/integrations/supabase/client";

interface UseUpcomingEventsOptions {
  sportSlug?: string;
  limit?: number;
  gender?: "Men" | "Women";
  categoryId?: string;
}

export function useUpcomingEvents(options?: UseUpcomingEventsOptions) {
  const { sportSlug, limit = 6, gender, categoryId } = options || {};
  const { organization } = useOrganizationContext();
  const eventService = useEventService(organization?.id || null);
  
  return useQuery({
    queryKey: ["upcoming-events", sportSlug, organization?.id, gender, categoryId],
    queryFn: async () => {
      if (!eventService) {
        return [];
      }
      
      console.log('🆕 Using EventService for upcoming events', { gender, categoryId });
      
      // For now, still use direct query for complex joins with sports
      // TODO: Extend EventService to support sport filtering
      let sportIds: string[] = [];
      if (sportSlug) {
        const sportName = sportSlug.charAt(0).toUpperCase() + sportSlug.slice(1);
        const { data: sports, error: sportError } = await supabase
          .from("sports")
          .select("id")
          .eq("name", sportName)
          .eq("active", true);
        
        if (sportError) {
          console.error("Error fetching sports:", sportError);
          throw sportError;
        }
        
        sportIds = sports?.map(s => s.id) || [];
      }

      // Use EventService for org-scoped query
      const events = await eventService.getUpcoming();
      
      // Filter by sport if needed
      let filtered = sportIds.length > 0
        ? events.filter(e => e.sport_id && sportIds.includes(e.sport_id))
        : events;
      
      // Filter by gender if specified
      if (gender) {
        filtered = filtered.filter(e => e.gender === gender);
      }
      
      // Filter by category if specified (event_category_ids is an array)
      if (categoryId) {
        filtered = filtered.filter(e => {
          const categoryIds = e.event_category_ids;
          return categoryIds && categoryIds.includes(categoryId);
        });
      }
      
      return filtered.slice(0, limit);
    },
    enabled: !!organization?.id && !!eventService,
  });
}
